import styles from "./horizantalBar.module.css";

const HorizantalBar = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};

export default HorizantalBar;
